import { getGuessStatuses } from './statuses'
import { GAME_TITLE } from '../constants/strings'
import { MAX_CHALLENGES } from '../constants/settings'

export const shareStatus = (
  guesses: string[],
  lost: boolean,
  solution: string,
  solutionIndex: number,
  dateKey: string,
  isToday: boolean,
  isHardMode: boolean,
  isDarkMode: boolean,
  isHighContrastMode: boolean
) => {
  const archiveLabel = isToday ? '' : ` (${dateKey})`

  navigator.clipboard.writeText(
    `${GAME_TITLE} ${solutionIndex}${archiveLabel} ${
      lost ? 'X' : guesses.length
    }/${MAX_CHALLENGES}${isHardMode ? '*' : ''}\n\n` +
      generateEmojiGrid(
        guesses,
        solution,
        getEmojiTiles(isDarkMode, isHighContrastMode)
      )
  )
}

export const generateEmojiGrid = (
  guesses: string[],
  solution: string,
  tiles: string[]
) => {
  return guesses
    .map((guess) => {
      const status = getGuessStatuses(guess, solution)
      return guess
        .split('')
        .map((_, i) => {
          switch (status[i]) {
            case 'correct':
              return tiles[0]
            case 'present':
              return tiles[1]
            default:
              return tiles[2]
          }
        })
        .join('')
    })
    .join('\n')
}

const getEmojiTiles = (isDarkMode: boolean, isHighContrastMode: boolean) => {
  let tiles: string[] = []
  tiles.push(isHighContrastMode ? '🟠' : '🟢')
  tiles.push(isHighContrastMode ? '🔵' : '🟣')
  tiles.push(isDarkMode ? '⚫️' : '⚪️')
  return tiles
}
